import { StyleRules } from '@material-ui/core/styles';
import { DialogActionsClassKey } from '@material-ui/core/DialogActions';

import { core as theme } from '../styles/core';

export const MuiDialogActions: Partial<StyleRules<DialogActionsClassKey>> = {
  root: {
    padding: theme.spacing(2, 3, 2),
  },
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: theme.spacing(2),
    },
  },
};
